import { Flex } from '@mantine/core';
import * as React from 'react';

import Text from 'components/shared/Text';

type Props = {
  className?: string;
  label: string;
  children: React.ReactNode;
};

const Item: React.FC<Props> = ({ className, label, children }) => {
  return (
    <Flex direction="column" gap="xxxs" align="flex-start" className={className}>
      <Text size="sm" c="gray">
        {label}
      </Text>
      <Text component="span" size="md">
        {children}
      </Text>
    </Flex>
  );
};

export default Item;
